import { useMemo } from "react";
import { CustomTypography } from "../../../components/CustomTypography/CustomTypography";
import { Sidebar } from "../../../containers/Sidebar/Sidebar";
import useStyles from "./styles";
import { CustomTable } from "../../../components/CustomTable/CustomTable";
import { CustomButtonTable } from "../../../components/CustomButtonTable/CustomButtonTable";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { getColumnsClaimsList } from "./columnsClaimsList";
import { useGetAllSinisters } from "../../../api/sinistre";
import { getCurrentFleetId } from "../../../utils/getCurrentFleet";
import { useServerPagination } from "../../../hooks/useServerPagination";
import { CustomLoader } from "../../../components/CustomLoader/CustomLoader";

type Props = {};

export const ListClaims: React.FC<Props> = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const pagination = useServerPagination();

  // Keye sur `t` : react-i18next renvoie une nouvelle identite au changement
  // de langue, donc les en-tetes et les chips se reconstruisent.
  const columns = useMemo(() => getColumnsClaimsList(t), [t]);
  const { sinistres, totalCount, isPending } = useGetAllSinisters(
    getCurrentFleetId(),
    pagination.page,
    pagination.perPage,
    pagination.search
  );

  return (
    <>
      {isPending && <CustomLoader isActive={isPending} />}
      <Sidebar
        styles={{
          sidebarRightRoot: classes.vehiculeRoot,
          sidebarRoot: classes.contentMain,
        }}
      >
        <div className={classes.containerHeader}>
          <CustomTypography
            variant="h2"
            text={t("claims.listOfClaims", "List of claims")}
            isUppercase
          />
          <CustomButtonTable
            variant={"primary"}
            textVariant={"link"}
            label={t("claims.addASinister", "Add a sinister")}
            width={"fit-content"}
            fontWeight={"bold"}
            textDecoration={"none"}
            iconName={"plus"}
            padding={"0px 15px"}
            textTransform="uppercase"
            onClick={() => navigate("/claims/create")}
          />
        </div>
        <CustomTable
          columns={columns}
          isFilterFromBackend
          tablePagnationCount={totalCount}
          {...pagination.tableProps}
          data={sinistres}
          isSearchable
          onClickButtonEye={() => navigate("/claims/update")}
        />
      </Sidebar>
    </>
  );
};
